import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_DAIRYT_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_DAIRYT_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_DAIRYT_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_DAIRYT_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_DAIRYT_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_DAIRYT_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_DAIRYT_MEASUREMENT_ID
};

// Initialize Firebase here
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;